import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CURRENT_LANGUAGE, DEFAULT_LANGUAGE } from './_common/constants';
import { TranslationService } from './_common/services/translation.service';
import { LoadingService } from './_common/services/loading.service';
import { delay, tap } from 'rxjs/operators';
import { fadeInOutAnimation } from './app.animations';
import { LegalNoticeDialogComponent } from './main/legal-notice-dialog/legal-notice-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { GdprDialogComponent } from './main/gdpr-dialog/gdpr-dialog.component';
import { Subscription } from 'rxjs';
import { AppService } from './app.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [
    fadeInOutAnimation
  ]
})
export class AppComponent implements OnDestroy, AfterViewInit {

  title = 'e-Pax';
  isLoading: boolean = false;
  isFromSignOut: boolean = false;
  hasTokenInQueryParams: boolean = false;
  languageList: string[];

  gdprDialogSubscription: Subscription;
  legalNoticeDialogSubscription: Subscription;

  constructor(
    public translateService: TranslateService,
    private translationService: TranslationService,
    private dialog: MatDialog,
    private loading: LoadingService,
    private appService: AppService,
  ) {
    this.languageList = this.translationService.translationList;    
    this.setLanguage();

    this.gdprDialogSubscription = this.appService.openGdprDialogCalled$.subscribe(() => {
      this.openGdprDialog();
    });
    this.legalNoticeDialogSubscription = this.appService.openLegalNoticeDialogCalled$.subscribe(() => {
      this.openLegalNoticeDialog();
    });
  }

  ngOnDestroy(): void {
    this.gdprDialogSubscription.unsubscribe();
    this.legalNoticeDialogSubscription.unsubscribe();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.listenToLoading();
    });
  }

  listenToLoading(): void {
    this.loading.loadingSub
      .pipe(delay(0),
        tap((loading) => this.isLoading = loading))
      .subscribe();
  }

  setLanguage() {
    const currentLang = sessionStorage.getItem(CURRENT_LANGUAGE);

    if(currentLang){
      this.translateService.use(currentLang);
      return;
    }

    const browserLang = navigator.language.split('-')[0];

    if (this.languageList && this.languageList.includes(browserLang)) {
      this.translateService.use(browserLang);
    } else {
      this.translateService.use(DEFAULT_LANGUAGE);
    }

    sessionStorage.setItem(CURRENT_LANGUAGE, this.translateService.currentLang);
  }

  public async openLegalNoticeDialog() {
    this.dialog.open(LegalNoticeDialogComponent, {
      width: '50vw',
      autoFocus: false,
      disableClose: true,
    });    
  }

  public openGdprDialog() {
    this.dialog.open(GdprDialogComponent, {
      width: '50vw',
      autoFocus: false,
      disableClose: true,
    });
  }
}